
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    links: {
      type: Array,
      default: () => []
    }
  },
  vessel: {
    container: {
      $attrs: 'all'
    },
    title: {
      fontSize: 'md',
      font: 'sans',
      fontWeight: 'semibold'
    },
    item: {
      fontSize: 'md',
      fontWeight: 'light'
    }
  },
  methods: {
    itemLabel(item) {
      if (item.translate)
        return this.$t(item.label)
      else
        return item.label
    }
  }
}
